import {
  GET_CUSTOMERS_REQUESTED,
  GET_CUSTOMERS_SUCCEEDED,
  GET_CUSTOMERS_FAILED,
  SEARCH_CUSTOMER_SUCCEEDED,
  SELECT_CUSTOMER,
  UPDATE_TOGGLE
} from './constants'
import { get } from 'lodash'
import DataMapper from '../../utils/dataMapper'

export const defaultState = {
  byId: {},
  toggle: {
    displayAssignedCustomers: true
  }
}

export default (state = defaultState, { type, payload }) => {
  switch (type) {
    case GET_CUSTOMERS_REQUESTED:
      return {
        ...state,
        isLoading: true,
      }

    case GET_CUSTOMERS_SUCCEEDED:
      const byId = DataMapper.objectsById(payload)

      return {
        ...state,
        byId,
        isLoading: false
      }

    case GET_CUSTOMERS_FAILED:
      return {
        ...state,
        isLoading: false
      }

    case SELECT_CUSTOMER:
      return {
        ...state,
        selectedCustomerId: payload
      }

    case SEARCH_CUSTOMER_SUCCEEDED:
      return {
        ...state,
        searchCustomerValue: payload
      }

    case UPDATE_TOGGLE:
      const key = get(payload, 'key', '')
      const value = get(payload, 'value', '')

      return {
        ...state,
        toggle: {
          ...state.toggle,
          [key]: value
        }
      }

    default:
      return state
  }
}
